// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3M5d8","cell":"ColumnAccessor_cell__3AURe","firstCellAccent":"ColumnAccessor_firstCellAccent__1sk8-"};